import {
  maxFrontEndDebt,
  taxes,
  privateMortgageInsurance,
  maxPurchasePrice,
  taxedValue,
  actualMonthlyTaxes,
  taxReliefMonthly,
  newMaxPrincipalAndInterest
} from './common'

export default class NewHome {
  static calculate(
    gmi,
    taxRate,
    hazardInsurance,
    landLeaseFee,
    interestRate,
    homesteadEx,
    homesteadExType
  ) {
    const iterations = 100 // Number of iterative calculations to perform (cross reference properties)

    const mfed = maxFrontEndDebt(gmi) // Max Front End Debt

    let txs = 0 // Taxes
    let pmi = 0 // Private Mortgage Insurance
    let mpi = 0 // Max Principal & Interest
    let mpp = 0 // Max Purchase Price

    for (let i = 0; i < iterations; i++) {
      txs = taxes(mpp, taxRate)
      pmi = privateMortgageInsurance(mpp)
      mpi = maxPrincipalAndInterest(
        mfed,
        txs,
        hazardInsurance,
        landLeaseFee,
        pmi
      )
      mpp = maxPurchasePrice(mpi, interestRate)
    }

    const result = {
      maxFrontEndDebt: Math.round(mfed),
      taxes: Math.round(txs),
      privateMortgageInsurance: Math.round(pmi),
      maxPrincipalAndInterest: Math.round(mpi),
      maxPurchasePrice: Math.round(mpp)
    }

    let txedValue
    let acmt
    let trf
    let newMpi
    let newMpp

    if (homesteadExType) {
      if (homesteadExType === 'flat') {
        trf = homesteadEx // taxReliefMonthlyFlat(txs, homesteadEx)
        result.taxReliefMonthly = Math.round(trf)
      } else {
        txedValue = taxedValue(mpp, homesteadEx)
        acmt = actualMonthlyTaxes(txedValue, taxRate)
        trf = taxReliefMonthly(txs, acmt)

        result.taxedValue = Math.round(txedValue)
        result.actualMonthlyTaxes = Math.round(acmt)
        result.taxReliefMonthly = Math.round(trf)
      }

      newMpi = newMaxPrincipalAndInterest(mpi, trf)
      newMpp = maxPurchasePrice(newMpi, interestRate)

      result.newMaxPrincipalAndInterest = Math.round(newMpi)
      result.newMaxPurchasePrice = Math.round(newMpp)
    }

    return result
  }
}

/**
 * @param maxFrontEndDebt - Calculated maxFrontEndDebt
 * @param taxes - Calculated taxes
 * @param hazardInsurance - Hazard Insurance - based on table by town
 * @param landLeaseFee - Land Lease fee
 * @param pmi - Private Mortgage Insurance
 * @return Max Principal & Interest
 */
const maxPrincipalAndInterest = (
  maxFrontEndDebt,
  taxes,
  hazardInsurance,
  landLeaseFee,
  pmi
) => {
  const mpi = maxFrontEndDebt - (taxes + hazardInsurance + landLeaseFee + pmi)
  return mpi
}
